import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { handleGetRequest } from "../services/GetTemplate";
import { useHistory } from "react-router-dom";
import { CiTrophy } from "react-icons/ci";
import UserAnalytics from "./analytics/UserAnalytics";
import PackageAnalytics from "./analytics/PackageAnalytics";
import FinancialAnalytics from "./analytics/FinancialAnalytics";
import styles from "./dashboard.module.scss";
import AdvancedAnalyticsDashboard from "./analytics/AdvancedAnalytics";

const Dashboard = () => {
    const history = useHistory();
    const [stats, setStats] = useState({
        users: 0,
        couriers: 0,
        clients: 0,
        packages: 0,
        labels: 0,
        Top: 0,
        Second: 0,
        date: "",
    });
    const [dataset, setDataSet] = useState([]);
    const [basicData, setBasicData] = useState({
        labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        datasets: [
            {
                label: "packages",
                data: dataset,
                fill: false,
                borderColor: "#42A5F5",
                tension: 0.4,
            },
        ],
    });
    const [activeTab, setActiveTab] = useState("overview");
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        try {
            setLoading(true);
            const data = await handleGetRequest("/allStats");
            setDataSet(data?.data?.resul);
            setStats({
                users: data?.data?.users,
                packages: data?.data?.packages,
                clients: data?.data?.clients,
                couriers: data?.data?.couriers,
                labels: data?.data?.labels,
                Top: data?.data?.Top,
                Second: data?.data?.Second,
                date: data?.data?.date,
            });
            setBasicData({
                labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                datasets: [
                    {
                        label: "packages",
                        data: data?.data?.resul,
                        fill: false,
                        borderColor: "#42A5F5",
                        tension: 0.4,
                    },
                ],
            });
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const getLightTheme = () => {
        let basicOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: "#495057",
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: "#495057",
                    },
                    grid: {
                        color: "#ebedef",
                    },
                },
                y: {
                    ticks: {
                        color: "#495057",
                    },
                    grid: {
                        color: "#ebedef",
                    },
                },
            },
        };

        let multiAxisOptions = {
            stacked: false,
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: "#495057",
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: "#495057",
                    },
                    grid: {
                        color: "#ebedef",
                    },
                },
            },
        };

        return {
            basicOptions,
            multiAxisOptions,
        };
    };

    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth() + 1;
    var currentDay = currentDate.getDate();

    const { basicOptions } = getLightTheme();

    if (loading) {
        return <div className={styles.dashboardLoading}>Loading Dashboard...</div>;
    }

    return (
        <div className={styles.dashboardWrapper}>
            {/* Top Overview Section */}
            <div className={styles.overviewSection}>
                <h1 className={styles.dashboardTitle}>Dashboard Overview</h1>

                {/* KPI Cards */}
                {/* <div className={styles.gridView}>
                    <div 
                        className={`${styles.card} ${styles.card1}`}
                        onClick={() => history.push("/customers")}
                    >
                        <i className="pi pi-user home_icon" />
                        <p>users</p>
                        <p className={styles.cardValue}>{stats?.users ?? 0}</p>
                    </div>
                    <div 
                        className={`${styles.card} ${styles.card2}`}
                        onClick={() => history.push("/customers?type=courier")}
                    >
                        <i className="pi pi-history home_icon" />
                        <p>Couriers</p>
                        <p className={styles.cardValue}>{stats?.couriers ?? 0}</p>
                    </div>
                    <div 
                        className={`${styles.card} ${styles.card3}`}
                        onClick={() => history.push("/customers?type=client")}
                    >
                        <i className="pi pi-circle home_icon" />
                        <p>Clients</p>
                        <p className={styles.cardValue}>{stats?.clients ?? 0}</p>
                    </div>
                    <div 
                        className={`${styles.card} ${styles.card4}`}
                        onClick={() => history.push("/packages")}
                    >
                        <i className="pi pi-circle home_icon" />
                        <p>Packages</p>
                        <p className={styles.cardValue}>{stats?.packages ?? 0}</p>
                    </div>
                    <div 
                        className={`${styles.card} ${styles.card5}`}
                        onClick={() => history.push("/labels")}
                    >
                        <i className="pi pi-car home_icon" />
                        <p>Labels</p>
                        <p className={styles.cardValue}>{stats?.labels ?? 0}</p>
                    </div>
                    <div className={`${styles.card} ${styles.card5} ${styles.topShipper}`}>
                        <i className={`home_icon ${styles.trophyIcon}`}>
                            <CiTrophy />
                        </i>
                        <p className={styles.shipperName}>{stats?.Top?.[0]}</p>
                        <p className={styles.shipperWeight}>{stats?.Top?.[1] ?? 0} Lbs</p>
                        <div className={styles.dateContainer}>
                            <p className={styles.dateText}>
                                {currentDay}-{currentMonth}-{currentYear}
                            </p>
                        </div>
                    </div>
                    <div className={`${styles.card} ${styles.card5} ${styles.secondShipper}`}>
                        <i className={`home_icon ${styles.trophyIcon}`}>
                            <CiTrophy />
                        </i>
                        <p className={styles.shipperName}>{stats?.Second?.[0]}</p>
                        <p className={styles.shipperWeight}>{stats?.Second?.[1] ?? 0} Lbs</p>
                        <div className={styles.dateContainer}>
                            <p className={styles.dateText}>
                                {currentDay}-{currentMonth}-{currentYear}
                            </p>
                        </div>
                    </div>
                </div> */}

                {/* Monthly Chart */}
                {/* <div className={styles.graphsSection}>
                    <div className={styles.chartContainer}>
                        <h5 className={styles.chartTitle}>Monthly Packages Added</h5>
                        <Chart type="line" data={basicData} options={basicOptions} />
                    </div>
                </div> */}
            </div>

            {/* Tab Navigation */}
            <div className={styles.tabNavigation}>
                <button
                    className={`${styles.tabButton} ${activeTab === "overview" ? styles.active : ""}`}
                    onClick={() => setActiveTab("overview")}
                >
                    📊 Overview
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "users" ? styles.active : ""}`}
                    onClick={() => setActiveTab("users")}
                >
                    👥 Users Analytics
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "packages" ? styles.active : ""}`}
                    onClick={() => setActiveTab("packages")}
                >
                    📦 Packages Analytics
                </button>
                <button
                    className={`${styles.tabButton} ${activeTab === "financial" ? styles.active : ""}`}
                    onClick={() => setActiveTab("financial")}
                >
                    💰 Financial Analytics
                </button>
            </div>

            {/* Tab Content */}
            <div className={styles.tabContent}>
                {activeTab === "overview" && (
                    <AdvancedAnalyticsDashboard />
                )}
                {activeTab === "users" && <UserAnalytics />}
                {activeTab === "packages" && <PackageAnalytics />}
                {activeTab === "financial" && <FinancialAnalytics />}
            </div>
        </div>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};

export default React.memo(Dashboard, comparisonFn);